<tg-row class="summary-page-promotions-section__header">
    <tg-col md="6" sm="12">
        <p class="p-lead-copy">Promotions</p>
    </tg-col>
    <tg-col
        md="6"
        sm="12"
        class="summary-page-promotions-section__header--right"
    >
        <a
            routerLink="../{{ stepIds.propertyPromote }}"
            routerLinkActive="active"
            class="h-link-no-visited"
            >Edit promotions</a
        >
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-promotions-section__content">
        <span class="summary-page-promotions-section__content-label"
            >{{ packageCopy }}:</span
        >
        {{ packageName }}
    </tg-col>
</tg-row>
